export default __webpack_public_path__ + "static/media/discover.f8e074b8.svg";